
import { mapMutations } from "vuex";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    modalImage: String,
    modalTitle: String,
    modalContent: String,
  },
  methods: {
    ...mapMutations(["setShowModal", "setModalTitle", "setModalContent"]),
    closeModal() {
      this.setShowModal(false);
      this.setModalTitle("");
      this.setModalContent("");
    },
    submitModal() {
      this.closeModal();
    },
  },
};
